import React, { ReactNode } from "react";
import { Box, BoxProps, Flex, FlexProps } from "@chakra-ui/react";

interface Props extends Omit<FlexProps, "children"> {
  header?: ReactNode;
  // 헤더와 본문 사이 구분선 — `필요한 설정` 카드처럼 목록을 이고 있을 때만 켠다.
  hasHeaderDivider?: boolean;
  // 아코디언 행이 카드 폭을 꽉 채워야 하는 카드는 "0"을 넘긴다.
  bodyPadding?: string;
  children?: ReactNode;
  headerProps?: BoxProps;
}

/**
 * 시작 가이드 전용 카드 셸.
 *
 * `PathPickSectionCard` 는 헤더 구분선이 항상 붙고 본문 패딩을 끌 수 없어서
 * 요약 카드(구분선 없음)와 설정 목록 카드(본문 패딩 0)를 함께 담지 못한다.
 * 반경/그림자만 공유하는 얇은 셸을 따로 둔다.
 */
function PathPickStartGuideCard({
  header,
  hasHeaderDivider = false,
  bodyPadding = "20px",
  children,
  headerProps,
  ...props
}: Props) {
  return (
    <Flex
      flexDirection={"column"}
      backgroundColor={"#FFFFFF"}
      borderRadius={"12px"}
      border={"0.5px solid #E5E5E3"}
      boxShadow={"0 1px 2px 0 rgba(0, 0, 0, 0.04)"}
      overflow={"hidden"}
      {...props}
    >
      {header && (
        <Box
          padding={"20px 20px 16px"}
          borderBottom={hasHeaderDivider ? "0.5px solid #E5E5E3" : undefined}
          {...headerProps}
        >
          {header}
        </Box>
      )}
      {children && <Box padding={bodyPadding}>{children}</Box>}
    </Flex>
  );
}

export default PathPickStartGuideCard;
